@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/variables';

.ghostButton {
  @include btn-sm-text;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  color: $white;
  cursor: pointer;
  padding: 6px 10px;
  text-align: center;
  transition: background-color ease-in-out 0.2s;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;

    &:hover,
    &:active {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.3);
  }
}
